module.exports = __webpack_public_path__ + "img/pda.cad0231c.svg";